'use strict';

import { FqComponents } from "../index";
import { Directive,Inject } from "@fiqas/angular-utils"
import * as angular from 'angular';

@Directive({
    module: FqComponents,
    selector: 'firstFocus'
})
export class FirstFocus implements angular.IDirective {
    constructor( @Inject('$timeout') private $timeout: angular.ITimeoutService) {

    }
    link($scope: angular.IScope, $elem: angular.IAugmentedJQuery, $attr: angular.IAttributes) {
        if (!!$attr["firstFocus"])
            this.$timeout(() => $elem[0].focus(), 200);
    }
}

@Directive({
    module: FqComponents,
    selector: 'focusSelect'
})
export class FocusSelect implements angular.IDirective {
    constructor( @Inject('$timeout') private $timeout: angular.ITimeoutService) {

    }
    link($scope: angular.IScope, $elem: angular.IAugmentedJQuery, $attr: angular.IAttributes) {
        if (!!$attr["focusSelect"])
            this.$timeout(() => (<HTMLInputElement>$elem[0]).select(), 200);
    }
};
